module.exports = __webpack_public_path__ + "static/img/default_error.997ed7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/defaultTip/img/default_error.jpg
// module id = 1BIL
// module chunks = 27